export enum WizardAppointmentsIdentifies {
  CONSULTATION = 'consultation',
  EXAMS = 'exams',
  EXAM_ADDITIONAL_INFORMATION = 'exam-additional-information',
  LOCATION = 'location',
  QUIZ = 'quiz',
  RANGE_DATE = 'range-date',
  SCHEDULE_TYPE = 'schedule-type',
  SCHEDULING_FOR = 'scheduling-for',
  SUGGESTION = 'suggestion',
}
